module.exports = __webpack_public_path__ + "img/6.becd6e3a.jpg";